/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
import FakeDiscussion from '../../../common/models/FakeDiscussion';

export default class LevelHistory extends Model {
	id = Model.attribute('id');
	level = Model.attribute('level');
	revision = Model.attribute('revision');

	// Add a fake discussion relationship, used to group notifications!
	discussion() {
		return new FakeDiscussion();
	}
}
